import DOMPurify from "dompurify";

// Blog bodies can carry HTML pasted from Notion/ChatGPT — always clean it before rendering.
export const sanitizeHtml = (html) => DOMPurify.sanitize(html || "", {
    ADD_ATTR: ["target", "rel"],
    FORBID_TAGS: ["style", "form", "input", "button"],
});
